import { SVGProps } from "react";
import I18n from "common/i18n";
import { getTitleFont } from "common/utils/font";

const getCourseText = () => {
  switch (I18n.locale) {
    case "en":
      return "Learn Courses";
    case "zh_tw":
      return "課程學習";
    default:
      return "コースでまなぶ";
  }
};

export const CourseTitleSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 321 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M320.99 53.74V6.25c-1.23-.42-2-4.32-4.43-5.67a3.983 3.983 0 0 0-.51-.23C239.67-.18 82.12-.22 1.38 1.02l-.1 5.28-.14 7.84-.13 7.68v.68l.14 5 .25 8.28.12 4.11.31 10.54.22 7.49h-.22l5 5.19.95.87 312.55-1.95.62-.63v-.62l.04-7.04Z"
      fill="#614018"
    />
    <path
      d="M314.71 56.06v.86s.01-.31 0-.86ZM314.68 15.52c2.1.29 4.21 5.06 6.31 5.53v-6.46c-2.1-.86-4.2-6.05-6.3-6.72l-.01 7.65Z"
      fill="#614018"
    />
    <path
      d="M320.99 14.59V6.25c-1.32-.44-2.14-4.86-4.94-5.9h-1.36V8.9c2.1.66 4.25 4.83 6.3 5.69Z"
      fill="#7E5320"
    />
    <path d="M314.7 48.73v8.19l6.25 4.5v-7.68c-2.01.46-4.15-5.54-6.25-5.01Z" fill="#614018" />
    <path
      d="M314.69 49.02c2.09-.53 4.21 5.18 6.3 4.72v-6.8c-2.1-.67-4.19-8.16-6.29-8.49l-.01 10.57ZM314.7 35.02c2.1-.81 4.19 5 6.29 5.06V33.4c-2.1-.24-4.19-5.1-6.29-5.23v6.85ZM314.69 20.8c2.09 0 4.2 6.09 6.3 5.34v-5.09c-2.1-.47-4.21-5.24-6.31-5.53l.01 5.28Z"
      fill="#7E5320"
    />
    <path
      d="M314.7 35.02v7c2.1.33 4.19 4.22 6.29 4.89v-6.83c-2.05-.11-4.19-5.87-6.29-5.06ZM314.69 21.46v6.71c2.1.13 4.19 5 6.29 5.23v-7.26c-2.1.75-4.21-5.37-6.3-5.34l.01.66Z"
      fill="#614018"
    />
    <path
      d="M320.99 53.74V6.25c-1.32-.44-2.14-4.86-4.94-5.9h-1.36v56.53l6.25 4.5v-.62l.05-7.02Z"
      fill="#614018"
      style={{
        mixBlendMode: "multiply",
      }}
      opacity={0.3}
    />
    <path
      d="m315.53 56.89.63-.64-.63.64ZM2.04 57.96c.61.57.95.87.95.87s-.34-.3-.95-.87ZM1.14 14.14c104.86.3 209.733.76 314.62 1.38l.13-6.62C210.997 8.007 106.127 7.14 1.28 6.3l-.14 7.84Z"
      fill="#614018"
    />
    <path
      d="m315.94 8.9.16-8.55C239.72-.18 82.17-.22 1.43 1.02l-.1 5.28c104.86.68 209.73 1.547 314.61 2.6Z"
      fill="#7E5320"
    />
    <path
      d="m1.82 50.45.22 7.51c.61.57.95.87.95.87l312.54-1.94.63-.64-.12-7.23c-104.733.44-209.473.917-314.22 1.43Z"
      fill="#614018"
    />
    <path
      d="M1.82 50.45c104.753-.547 209.493-1.023 314.22-1.43l-.1-7c-104.83-.69-209.54-1.8-314.43-2.14l.31 10.57ZM1.39 35.8c104.64-.82 209.57-.89 314.43-.78l-.1-6.85c-104.86-.24-209.72-.457-314.58-.65l.25 8.28ZM1.01 21.82c104.8 0 209.683-.363 314.65-1.09l.1-5.21c-104.893-.487-209.767-.947-314.62-1.38l-.13 7.68Z"
      fill="#7E5320"
    />
    <path
      d="m1.39 35.8.12 4.11c104.89.34 209.6 1.45 314.43 2.14l-.12-7c-104.88-.14-209.79-.07-314.43.75ZM1 22.5l.14 5c104.873.14 209.733.357 314.58.65l-.09-5.67v-1.77C210.77 21.477 105.887 21.84.98 21.8l.02.7ZM1.82 57.94l5 5.19.95.87 312.55-1.95.62-.63-4.94-4.91c-104.707.473-209.433.95-314.18 1.43Z"
      fill="#614018"
    />
    <path
      d="m1.82 57.94 5 5.19.95.87 312.55-1.95.62-.63-4.94-4.91c-104.707.473-209.433.95-314.18 1.43Z"
      fill="#614018"
      style={{
        mixBlendMode: "multiply",
      }}
      opacity={0.3}
    />
    <text
      x="161"
      y="42"
      fill="#fff"
      fontSize="36"
      fontFamily={getTitleFont()}
      fontWeight="400"
      textAnchor="middle"
    >
      {getCourseText()}
    </text>
  </svg>
);
